export default __webpack_public_path__ + "static/media/identifiants_connexion.0b3062d7.svg";